import React from "react";
import Logo from "./Logo";
import cucina_red from "../images/cucina_2.jpg";
import heroImage from "../images/cucina_chiusa.jpg";
import food2 from "../images/nuvole.JPG";
import food1 from "../images/chef.JPG";
import food3 from "../images/martini.JPG";

export default function LaCucina() {
  return (
    <div className="text-black">
      <Logo />

      {/* Main content area with consistent margin */}
      <div className="m-[100px]">
        {/* Hero Section */}
        <div className="relative w-full h-[60vh]">
          <img
            src={cucina_red}
            alt="SoundRoom Hero"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0  bg-opacity-40 flex items-center justify-center">
            <h1 className="text-white text-5xl font-extrabold">LA CUCINA</h1>
          </div>
        </div>
        <br></br>
        <div className="relative w-full h-[100vh]">
          <img
            src={food3}
            alt="SoundRoom Hero"
            className="w-full h-full object-cover"
          />
        </div>
        {/* Concept Section */}
        <section className="flex flex-col md:flex-row items-center gap-8 mt-16">
          <img
            src={food1}
            alt="SoundRoom Experience"
            className="w-full md:w-1/2 rounded-lg shadow-lg"
          />{" "}
          <img
            src={food2}
            alt="SoundRoom Experience"
            className="w-full md:w-1/2 rounded-lg shadow-lg"
          />
        </section>
      </div>
    </div>
  );
}
